import { gql } from "graphql-tag";

export const VIEWER_QUERY = gql`
  query getViewer {
    viewer {
      id
      roles
      isClient
      isAdmin
      isSupervisor
      isPropManager
      email
      firstName
      lastName
      fullName
      organizationId
      organization {
        id
        name
        logoFilename
        bccEmail
      }
      lists {
        id
        name
        scheduledUpdate {
          enabled
        }
      }
      properties {
        id
        name
      }
      features {
        id
        name
      }
    }
  }
`;
